import Layout from 'components/Layout';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import SMSTpl from 'templates/SMSTpl';

const Tpl = props => (
  <Layout location={props.location}>
    <SMSTpl {...props} />
  </Layout>
);
const Index = props => {
  const data = useStaticQuery(graphql`
    query SmsQuery {
      smsPage: smsJson {
        title
        meta {
          description
          breadcrumb {
            link
            text
          }
        }
        banner {
          heading
          content
          img {
            publicURL
          }
          isNew
          imageAsBg
        }
        twoCols {
          heading
          content
          img {
            publicURL
          }
        }
        carousel {
          heading
          desc
          list {
            heading
            content
            img {
              publicURL
            }
          }
        }
        freeTrial {
          heading
          subheading
          btnText
        }
        threeCols {
          heading
          desc
          list {
            heading
            content
            img {
              publicURL
            }
          }
        }
        featuresHeading {
          heading
          desc
          cta {
            to
            text
            type
          }
        }
        featuresList {
          heading
          content
          img {
            publicURL
          }
        }
        smsfooter {
          heading
          description
          link
          image {
            publicURL
          }
          list {
            heading
            desc
          }
        }
        smsQA {
          list {
            q
            a
          }
        }
      }
    }
  `);
  return (<Tpl data={data} {...props} />);
};

Tpl.propTypes = {
  location: PropTypes.object,
};

export default Index;
